import React, { createContext, useCallback, useContext, useState } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './UserUIHelpers';

const UserUIContext = createContext();

export function useUserUIContext() {
    return useContext(UserUIContext);
}

export const UserUIConsumer = UserUIContext.Consumer;

export function UserUIProvider({ userUIEvents, children }) {
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback((nextQueryParams) => {
        setQueryParamsBase((prevQueryParams) => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    let initUser = {
        name: '',
        email: '',
        role: '',
        access_role_uuid: '',
        channel_uuid: '',
        change_pass: false,
        password: '',
        is_active: true
    };

    const value = {
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        initUser,
        newUserButtonClick: userUIEvents.newUserButtonClick,
        openEditUserPage: userUIEvents.openEditUserPage,
    };

    return (
        <UserUIContext.Provider value={value}>
            {children}
        </UserUIContext.Provider>
    );
}
